import { Tooltip, Typography } from "@mui/material";

const Name = ({ fontSize, name }) => {
  return (
    <Tooltip title={name}>
      <Typography noWrap {...{ fontSize, sx: { cursor: "default" } }}>
        {name}
      </Typography>
    </Tooltip>
  );
};

export default Name;
